import React, { useContext, useEffect, useState } from "react";

import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useNavigate } from "react-router-dom";
import User from "../../Services/userServices";
import { AuthContext } from "./../../Auth/Context/AuthContext";
import { Table, message } from "antd";

function UserList(props) {
  const { user } = useContext(AuthContext);

  const columns = [
    {
      dataIndex: "profile_picture_url",
      title: "Profile",
      formatter: (cell, row) => (
        <img
          style={{ maxWidth: "30%" }}
          src={row.profile_picture_url || "images/profile.png"}
        />
      ),
    },
    {
      dataIndex: "username",
      title: "User Name",
    },
    {
      dataIndex: "email",
      title: "Email",
    },
    {
      dataIndex: "phone",
      title: "Phone",
    },
    {
      dataIndex: "role",
      title: "Role",
    },
    {
      dataIndex: "action",
      title: "Action",
      formatter: (cellContent, row) => {
        return (
          <div>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => editUser(row.id)}
            >
              <img src="assets/img/icons/edit.svg"></img>
            </button>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => deleteUser(row.id)}
            >
              <img src="assets/img/icons/delete.svg"></img>
            </button>
          </div>
        );
      },
    },
  ];
  const navigate = useNavigate();
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUserList = async () => {
    setLoading(true);
    await User.getAll()
      .then((data) => {
        setUserList(data.data);
        console.log("userList", data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const editUser = (id) => {
    navigate(`/edit-user/${id}`);
  };

  const deleteUser = async (id) => {
    if (user.id === id) {
      message.error("Current user can't be deleted");
      return;
    }
    setLoading(true);
    await User.remove(id)
      .then((response) => {
        message.success("Deleted Successfully");
        getUserList();
      })
      .catch((err) => {
        if (err.response?.data) {
          setLoading(false);
          message.error(err.response.data.message);
        }
        console.log(err);
      });
  };

  useEffect(() => {
    getUserList();
  }, []);
  console.log("____ userList", userList);
  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>User List</h4>
              <h6>Manage your User</h6>
            </div>
            <div class="page-btn">
              <a href="add-user" class="btn btn-added">
                <img src="/assets/img/icons/plus.svg" alt="img" class="me-2" />
                Add User
              </a>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <Table
                columns={columns}
                dataSource={userList?.map((item) => ({
                  profile_picture_url: (
                    <img
                      src={item.profile_picture_url || "images/profile.png"}
                      width={25}
                      height={25}
                    />
                  ),
                  username: item.username,
                  email: item.email,
                  phone: item.phone,
                  role: item.role,
                  action: (
                    <div>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => editUser(item.id)}
                      >
                        <img src="assets/img/icons/edit.svg"></img>
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() => deleteUser(item.id)}
                      >
                        <img src="assets/img/icons/delete.svg"></img>
                      </button>
                    </div>
                  ),
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserList;
